import React from 'react';
import { ButtonsContainer } from './ButtonsGroup.styled';

const ButtonsGroup: React.FC = ({ children }) => (
  <ButtonsContainer>{children}</ButtonsContainer>
);

export default ButtonsGroup;
